export default {
    serviceConfig: {
        create: '新增配置',
        'create.success': '新增配置成功',
        'update.success': '更新配置成功',
        'update.conflict': '该配置已被他人更新，已为你加载最新数据，请确认后重新提交。',
        'delete.confirm': '确认删除该配置？',
        'drawer.createTitle': '新增服务配置',
        'drawer.editTitle': '编辑服务配置',
        'detail.createTitle': '新增服务配置',
        'detail.viewTitle': '配置详情',
        'detail.editTitle': '编辑服务配置',
        table: {
            key: 'Key',
            type: '类型',
            module: '模块',
            value: 'Value',
            updatedAt: '更新时间',
            createdAt: '创建时间',
            actions: '操作',
            logs: '操作记录',
        },
        form: {
            key: 'Key',
            'key.required': '请输入 Key',
            'key.placeholder': '请输入配置 Key',
            module: '模块',
            'module.required': '请输入模块',
            'module.placeholder': '请输入模块名称',
            type: '类型',
            'type.required': '请选择类型',
            value: 'Value',
            'value.required': '请输入配置内容',
            'value.invalidJson': '配置内容必须是合法 JSON',
        },
        type: {
            public: '公开',
            private: '私有',
        },
    },
};
